// extracted by mini-css-extract-plugin
export default {"addToBasketRecsContainer":"bB3g4ykbo1SAicoLXlKg","addToBasketRecsContainerHasCarousel":"UelqMKOmYsSxftDJCH9g"};